<div class="cv-bbox-banner" *ngIf="visible" role="region" aria-label="BBox search summary">
  <div class="cv-bbox-banner__header">
    <h2 class="cv-bbox-banner__title">Bbox search</h2>
    <button type="button" class="cv-bbox-banner__back-link" (click)="backToDatasets.emit()">
      Back to datasets
    </button>
  </div>

  <p class="cv-bbox-banner__message">
    Found {{ resourceCount }} resource{{ resourceCount === 1 ? '' : 's' }} — click markers to add to
    your selection
    <span *ngIf="selectedCount > 0"> ({{ selectedCount }} selected)</span>
  </p>

  <div class="cv-bbox-banner__actions">
    <button type="button" class="cv-bbox-banner__btn cv-bbox-banner__btn--primary" (click)="listAllResults.emit()">
      List All Results ({{ resourceCount }})
    </button>
    <button type="button" class="cv-bbox-banner__btn cv-bbox-banner__btn--secondary" (click)="clearBbox.emit()">
      Clear Bbox
    </button>
  </div>
</div>
